/**
 * src/utils/testFixtures.ts — frontend mirror of the test-fixture-email
 * detection used by resources/lib/billingHooks.js. Keep these patterns in
 * lockstep — server validates fixtures by the same regexes when deciding
 * to bypass Stripe + skip billing sync.
 *
 * Used by OnboardingChecklist to render a "Seed test card" shortcut for
 * fixture customers (without exposing it to real customers, whose emails
 * never match these patterns).
 */

const TEST_EMAIL_PATTERNS: RegExp[] = [
  /^e2e[-+]/i,            // e2e+clerk_test+...@..., e2e-pickup-target+...
  /clerk_test/i,          // belt-and-suspenders for any Clerk-test fixture rows
];

export function isTestFixtureEmail(email: string | null | undefined): boolean {
  if (typeof email !== 'string' || !email) return false;
  return TEST_EMAIL_PATTERNS.some((re) => re.test(email));
}
